module.exports = "<div class=\"content\" role=\"main\">\n  <div class=\"d3-chart container tree\" #chart></div>\n</div>"